// The one active interaction. Module-scoped so that view/handler files can
// read it without going through main.ts; writes go through `setInteraction`
// since `export let` rebindings aren't visible to importers without an
// explicit setter.
//
// Default state is "idle" — no drag, no commit in flight. Every
// gesture-finalize path resets to idle.

import { type Interaction } from "./types";

export let interaction: Interaction = { kind: "idle" };

// Generic + identity-return so callers can pass the narrowed shape inline:
//   const live = setInteraction({ kind: "draw", … });
//   runStep(live);   // `live` keeps the narrow "draw" type
// (Reading the bare `interaction` import after a set doesn't narrow — ES
// module bindings don't flow through TypeScript's control-flow analysis.)
export function setInteraction<I extends Interaction>(next: I): I {
  interaction = next;
  return next;
}
